import { InitState } from '@corbado/shared-ui';
import { createContext } from 'react';
export const initialContext = {
    currentScreen: undefined,
    initState: InitState.Initializing,
};
const FlowHandlerContext = createContext(initialContext);
export default FlowHandlerContext;
